import { EventBus, EventsList } from "../Events/index"

const handleError = error => {
    console.error(error)
    EventBus.$emit(EventsList.SHOW_EVENT_ERROR, error?.response?.data?.message || error?.response?.data?.error || error)
}

export default handleError
